import { Component } from '@angular/core'

@Component({
  selector: 'app-admin-report-sidebar',
  templateUrl: './admin-report-sidebar.component.html',
  styleUrls: ['./admin-report-sidebar.component.scss'],
})
export class AdminReportSidebarComponent {}
